<div class="client_chat_wrapper">
    <div class="chat_body_wrapper">
        <div class="chat_body_top_wrapper">
            <div class="chat_body_top">
                <button class="button_exit" v-if="isOwner" @click="removeOwner"><span class="button_text">{{$t('chat.exit_chat')}}</span><img class="button_exit_img" src="/assets/img/logout.svg"></button>
                <button class="button_owner" v-if="!isOwner && roomId" @click="assignAsOwner"><span class="button_text">{{$t('chat.become_owner')}}</span><img class="button_owner_img" src="/assets/img/edit-name-white.svg"></button>
            </div>
        </div>
        <div class="chat_content_wrapper">
            <div class="overflow-hidden" :style="{ 'min-height': `calc(100% - ${36 + textareaHeight}px)` }">
                <div class="chat_body" id="clientChatMessages">
                    <p class="info_text" v-if="messageInformation">{{messageInformation ? $t(messageInformation) : messageInformation}}</p>
                    <div class="start_chat_wrapper" v-else-if="showStartChat">
                        <p class="info_text_static">{{ $t('chat.no_chat_for_client') }}</p>
                        <button class="button_start_chat" @click="createRoom">
                            <span>{{ $t('chat.start_chat') }}</span>
                            <img class="button_start_chat_img" src="/assets/img/send.svg">
                        </button>
                    </div>
                    <div v-for="message in messages" v-else :key="message.messageId">
                        <div class="technical_message" v-if="message.isTechnicalMessage">
                            <p class="m-0">{{ message.isTranslated ? $t(message.text) : message.text}}</p>
                            <p class="message_date" v-if="!message.isTechnicalMessage">{{message.sendDate}}</p>
                        </div>

                        <div :class="message.isClubMessage ? 'club_message' : 'client_message'" v-else>
                            <p class="m-0" v-html="message.text"></p>
                            <p class="message_date" v-if="!message.isTechnicalMessage">{{message.sendDate}}</p>
                        </div>

                    </div>
                </div>

            </div>
            <div class="chat_body_footer_wrapper" :style="{ 'min-height': `${36 + textareaHeight}px` }">
                <ChatTemplateDropdown
                    :show="isTemplatesOpen"
                    :templates="templates"
                    :loading="isTemplatesLoading"
                    :error="templatesError"
                    @select="selectTemplate"
                    @close="isTemplatesOpen = false"
                />
                <div class="chat_body_footer" v-show="isOwner && !connectionInformation">
                    <button v-if="showTemplatesButton" class="template_button" :class="{ template_button_active: isTemplatesOpen }" @click="toggleTemplates" :title="$t('chat.templates')">
                        <img class="template_button_img" src="/assets/img/document-folder.svg" />
                    </button>

                    <div class="textarea_wrapper" :class="{ active: isTextareaFocused, 'no-template-button': !showTemplatesButton }">
                        <textarea :placeholder="$t('chat.enter_message')" class="textarea" v-model="message" @keydown="updateTextarea($event)" @input="changeTextArea" @focus="isTextareaFocused = true" @blur="isTextareaFocused = false" id="clientChatTextarea" />
                    </div>

                    <button class="message_send_button" @click="sendMessage"><img class="message_send_button_img" src="/assets/img/send.svg" /></button>
                </div>
                <p class="info_text" v-show="connectionInformation">{{connectionInformation ? $t(connectionInformation) : connectionInformation}}</p>
            </div>
        </div>

    </div>

</div>
